module.exports = __webpack_public_path__ + "img/youtube.da51e16.svg";